<template>
  <div class="">
    <div class="index_oo">
      <div class="index1_until cpoint">
        <div class="index1_until_shu"></div>
        <div class="index1_until_text">政策通知</div>
      </div>
      <div class="box3 cpoint">
        <div class="box3_right" style="width: 100%">
          <div class="box3_center" style="width: 100%">
            <input @keyup.enter.prevent="searchEnterFun($event)" v-model="keyword" placeholder="请输入您要搜索的关键词" />
            <div @click="tosearch" class="box3_sou">
              <div class="box3_tu">
                <img style="width: 25px;height: 25px;" src="/static/assets/images/sou.png" />
              </div>
              <div>搜索</div>
            </div>
          </div>
          <!-- <div class="box3_lie">导出列表</div> -->
        </div>
      </div>
      <div class="box55 cpoint">
        <div class="box2">
          <div class="box2_center" style="min-height: 545px;">
            <table
              class="bo"
              cellpadding="0"
              cellspacing="0"
              style="font-size: 15px"
            >
              <tr class="bo_cc" style="font-size: 18px">
                <td>序号</td>
                <td style="width: 260px;" v-if="systeminfo.system_type == 2 || systeminfo.system_type == 3">公司名称</td>
                <td style="width: 260px;">政策名称</td>
                <td>开始时间</td>
                <td>截止时间</td>
                <td>查看详情</td>
                <td>操作</td>
              </tr>
              <tr v-for="(item,index) in list" :key="index" class="trcla">
                <td>{{index + 1}}</td>
                <td style="width: 260px;" v-if="systeminfo.system_type == 2 || systeminfo.system_type == 3">{{item.company_name}}</td>
                <td style="width: 260px;">{{item.title}}</td>
                <td>{{item.start_time}}</td>
                <td>{{item.end_time}}</td>
                <td>
                  <div
                    class="flex justify-around align-center"
                    style="color: #6491ff"
                  >
                  <!-- todetail(item.id) -->
                    <div @click="outweb(item.link)">政策详情</div>
                    <!-- <div @click="tocom(item.company_id)">企业详情</div> -->
                  </div>
                </td>
                <td class="box2_tt flex justify-around align-center">
                  <div
                    class="flex justify-around align-center"
                    style="width: 75%"
                  >
                    <el-popconfirm @confirm="tofollow(item.id,item.company_id)" title="确定跟进？">
                      <el-button style="border: 1px solid #6491ff;border-radius: 15px !important;color: #6491ff;padding: 0 20px;height: 30px;line-height: 30px;" slot="reference">跟进</el-button>
                    </el-popconfirm>
                    <!-- <div @click="tofollow(item.id,item.company_id)" class="box2_text">跟进</div> -->
                    <el-popconfirm @confirm="todelete(item.id,item.company_id,index)" title="确定删除吗？">
                      <el-button style="border: 1px solid #6491ff;border-radius: 15px !important;color: #6491ff;padding: 0 20px;height: 30px;line-height: 30px;" slot="reference">删除</el-button>
                    </el-popconfirm>
                  </div>
                </td>
              </tr>
            </table>
            <div @click="emptyedit">
                <nomore v-if="!list.length" ></nomore>
            </div>
          </div>
          <div class="response text-center padding-tb">
            <el-pagination
              background
              :page-size="pagesize"
              :hide-on-single-page="true"
              layout="prev, pager, next"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :total="totalnum">
              </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="预警详情" :visible.sync="addcompany" >
      <div class="" style="text-align: center;width: 60%;margin: 0 auto;">
        <el-form :model="cominfo" style="text-align:center;">
          <el-form-item label="公司名称" :label-width="formLabelWidth">
            <el-input style="width: 420px;" placeholder="请输入" v-model="cominfo.company_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="法人姓名" :label-width="formLabelWidth">
            <el-input style="width: 420px;" placeholder="请输入" v-model="cominfo.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" :label-width="formLabelWidth">
            <el-input style="width: 420px;" placeholder="请输入" v-model="cominfo.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="房屋信息" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.office" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="入驻时间" :label-width="formLabelWidth">
            <el-date-picker
                v-model="cominfo.start_time"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                style="width: 420px">
              </el-date-picker>
          </el-form-item>
          <el-form-item label="费用到期时间" :label-width="formLabelWidth">
            <el-date-picker
                v-model="cominfo.end_time"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                style="width: 420px">
              </el-date-picker>
          </el-form-item>
          <el-form-item label="实付总数" :label-width="formLabelWidth">
            <el-input style="width: 420px;" placeholder="请输入" v-model="cominfo.real_pay" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="押金" :label-width="formLabelWidth">
            <el-input style="width: 420px;" placeholder="请输入" v-model="cominfo.yajin" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="合同序号" :label-width="formLabelWidth">
            <el-input style="width: 420px;" placeholder="请输入" v-model="cominfo.number" autocomplete="off"></el-input>
          </el-form-item>

        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return{
      list: [],
      keyword: '',
      pagesize: 8,
      currentPage: 1,
      totalnum: null,
      systeminfo: '',
      addcompany: false,
       cominfo:{
        id: '',
        start_time: '',
        company_name: '',
        name: '',
        phone: '',
        office: '',
        end_time: '',
        // last_money: '',
        // last_time: '',
        // pay_total: '',
        // dis_money: '',
        real_pay: '',
        yajin: '',
        number: '',
        user_id: '',
        super_id: ''
      },
    }
  },
  computed: {
    userid() {
      return this.$store.state.userid;
    }
  },
  methods:{
      emptyedit(){
      this.addcompany = true;
    },
    handleCurrentChange: function(currentPage){
        this.currentPage = currentPage;
        // console.log(this.currentPage)  //点击第几页
        // this.rightlist = [];
        this.getlist();
    },
    handleSizeChange(size){
        // this.pagesize = size;
        console.log(size)  //每页下拉显示数据
    },
    // policy_matching_list
    outweb(link){
      window.open(link,'_target')
    },
    getlist(){
      var api = this.$api.api.vector.policy_matching_list;
      this.$https.post({
        type: 'formData',
        api: api
      },{
        id: this.systeminfo.id,
        keyword: this.keyword,
        user_id: this.userid,
        start: this.currentPage,
        page_size: this.pagesize
      },
      response=>{
        this.list = response.data;
        this.totalnum = response.count;
      },
      error=>{
        console.log(error)
      })
    },
    searchEnterFun(e){
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
          this.tosearch();
      }
		},
    tosearch(){
        this.getlist();
    },
    todetail(id){
      this.$router.push({name: 'zcpolicydetail',query:{type: this.type,id: id}})
    },
    tocom(id){
      // companydetail
       this.$router.push({name: 'companydetail',query:{path: 'zcpolicy',id: id}})
    },
     todelete(id,company_id,index){

      // var api = this.$api.api.vector.day_policydel;
      var api = this.$api.api.vector.policytui_del;
      this.$https.post({
        api:api,
          type: 'formData'
        },{
         id: id
        },
        response=> {
        // console.log('manager_listtttttttttt',response);
          this.$message({
            message: response.msg,
            type: 'success',
            duration: 800
          });
          this.list.splice(index,1)
          },
        error=> {
          // console.log(error)
          this.$message({
            message: error.msg,
            type: 'warning'
          });
       })
    },
    tofollow(id,company_id){
      var api = this.$api.api.vector.follow_up;
      this.$https.post({
        type: 'formData',
        api: api
      },{
        company_id: company_id,
        policy_id: id,
        user_id: this.userid,
        super_id: this.systeminfo.super_id
      },
      response=>{
        this.$message({
          message: response.msg,
          type: "success",
        });
        this.getlist();
      },
      error=>{
        this.$message({
          message: error.msg,
          type: "warning",
        });
      })
    },
  },
  created(){
    this.getlist();
  }
}
</script>
<style scoped>
.index_oo {
  min-height: 666px;
  justify-content: flex-start !important;
}
.box55{
    width: 100%;
}
.bo {
  margin-top: 24px;
  /* margin-bottom: 70px; */
  border-bottom: 1px solid #efefef;
  width: 100%;
}
.bo_cc {
  background-color: #6491ff;
  font-size: 18px;
  color: #ffffff;
}
.bo_cc td {
  height: 56px;
  line-height: 56px;
  text-align: center;
  padding: 0 9px;
  border-top: 1px solid #efefef;
  border-left: 1px solid #efefef;
}
.trcla td {
  /* line-height: 85px; */
  text-align: center;
  padding: 0 9px;
  height: 60px;
  border-top: 1px solid #efefef;
  border-left: 1px solid #efefef;
}
.box2_text {
  height: 30px;
  background-color: #ffffff;
  border-radius: 15px;
  border: solid 1px #6491ff;
  font-size: 14px;
  color: #6491ff;
  margin-left: 13px;
  padding: 0 20px;
  line-height: 30px;
  text-align: center;
}

.box2_text1 {
  width: 91px;
  height: 30px;
  background-color: #6491ff;
  border-radius: 15px;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box2 {
  width: 95%;
  margin: 0 auto;
}
.box3 {
  display: flex;
  width: 95%;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}
.box3_center {
  width: 83%;
  height: 48px;
  background-color: #ffffff;
  box-shadow: 0px 2px 18px 0px rgba(141, 142, 144, 0.24);
  border-radius: 8px;
  border: solid 1px #eeeeee;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box3_lie {
  width: 123px;
  height: 42px;
  background-color: #ffffff;
  border-radius: 21px;
  border: solid 1px #6491ff;
  font-size: 18px;
  color: #6491ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
}
.box3_lie1 {
  width: 123px;
  height: 42px;
  background-color: #6491ff;
  border-radius: 21px;
  border: solid 1px #6491ff;
  font-size: 18px;
  color: #ffffff;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  bottom: 70px;
}
.box3_right {
  width: 64%;
  display: flex;
  align-items: center;
  position: relative;
}
input {
  width: 90%;
  background: none;
  outline: none;
  border: none;
  margin-left: 20px;
}
.box3_tu {
  width: 25px;
  height: 25px;
  margin-right: 8px;
}
.box3_sou {
  display: flex;
  width: 90px;
  align-items: center;
  height: 100%;
  font-size: 18px;
  color: #6491ff;
}
.box3_text {
  font-size: 18px;
  color: #a3a3a3;
  height: 35px;
  display: flex;
  padding: 0 7px;
  align-items: center;
  border-bottom: 4px solid #ffffff;
}
</style>



// WEBPACK FOOTER //
// account.vue?f99f811c